import { Box, styled, Card, Avatar, alpha } from '@mui/material';

interface FamilyCoveredFirstStyledProps {
  hasFamilyMembers: boolean;
}
export const FamilyCoveredSectionStyled = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
})) as typeof Box;

export const FamilyCoveredCardStyled = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  overflowX: 'auto',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  border: `0.1rem solid ${theme.palette.grey[200]}`,
})) as typeof Card;

export const FamilyCoveredFirstStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasFamilyMembers',
})<FamilyCoveredFirstStyledProps>(({ theme, hasFamilyMembers }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '60px',
  minWidth: '60px',
  overflow: 'hidden',
  paddingRight: theme.spacing(3),
  ...(hasFamilyMembers && {
    borderRight: `0.1rem solid ${theme.palette.grey[200]}`,
  }),
})) as typeof Box;

export const FamilyCoveredCircleStyled = styled(Avatar)(({ theme }) => ({
  width: 48,
  height: 48,
  padding: theme.spacing(1),
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
}));
